const IconMagnifyingGlassBold = props => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.16667 1.66669C5.02454 1.66669 1.66667 5.02455 1.66667 9.16669C1.66667 13.3089 5.02454 16.6667 9.16667 16.6667C10.9375 16.6667 12.565 16.0529 13.8481 15.0266L16.9108 18.0893C17.2362 18.4147 17.7638 18.4147 18.0893 18.0893C18.4147 17.7639 18.4147 17.2362 18.0893 16.9108L15.0266 13.8481C16.0529 12.565 16.6667 10.9375 16.6667 9.16669C16.6667 5.02455 13.3088 1.66669 9.16667 1.66669ZM3.33334 9.16669C3.33334 5.94503 5.94501 3.33335 9.16667 3.33335C12.3883 3.33335 15 5.94503 15 9.16669C15 12.3884 12.3883 15 9.16667 15C5.94501 15 3.33334 12.3884 3.33334 9.16669Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default IconMagnifyingGlassBold;
